// extracted by mini-css-extract-plugin
module.exports = {"pageTop":"PageTopText_pageTop__H_dtw","inner":"PageTopText_inner__yoh_g","title":"PageTopText_title__6FIdm","text":"PageTopText_text__3rljT"};